<template>
  <section>
    <h2 class="h2Title">제품 관리</h2>
    <div class="dashWrap">
      <div class="dashRow">
        <h2 class="tit">
          <span>{{ id ? '제품 수정' : '제품 등록'}}</span>
        </h2>

        <div class="dashBx">
          <v-form ref="formProduct">
            <v-row>
              <v-col cols="12" md="5">
                <vue-dropzone
                    ref="productDropzone"
                    id="dropzone"
                    :options="dropzoneOptions"
                    :useCustomSlot="true"
                    @vdropzone-success="uploadSuccess"
                    @vdropzone-removed-file="uploadRemove"
                    @vdropzone-processing="processingEvent"
                >
                  <div class="dropzone-custom-content">
                    <h3 class="dropzone-custom-title">제품 이미지</h3>
                    <div class="subtitle">이미지 파일을 끌어 놓거나 컴퓨터에서 파일을 선택해주세요.</div>
                  </div>

                </vue-dropzone>

              </v-col>
              <v-col cols="12" md="4">

                <div class="d-flex"></div>
                <div class="font-weight-bold text-h5">
                  <v-text-field label="제품명" v-model="product.productName" :rules="[rules.common.required]" maxlength="120"/>
                </div>
                <v-divider class="my-2"></v-divider>
                <div class="d-flex align-center text-h6">
                  <v-text-field label="소비자가격" v-model="product.price" :rules="[rules.common.required, rules.common.digit]" maxlength="50"
                                @keyup="onlyNumber"
                                prepend-icon="mdi mdi-currency-krw"
                  />
                </div>
                <v-divider class="my-2"></v-divider>

                <div class="font-weight-bold mb-1">세부 스펙</div>
                <ul>
                  <li>
<!--                    <v-text-field type="number" label="수량" v-model="product.stock" :rules="[rules.common.required, rules.common.digit]" maxlength="50"-->
<!--                                  @keypress="onlyNumber"-->
<!--                                  @keyup="onlyNumber"-->
<!--                                  oninput="if((this.value.length) > 7) this.value = this.value.substring(0, 7);"-->
<!--                    />-->
                  </li>
                </ul>

              </v-col>
              <v-col cols="12" md="3">
                <v-card>
                  <categories  @callback-clicked="selectCategory" :selected="product.categoryId"/>
                </v-card>
              </v-col>
            </v-row>

            <div v-if="product.productImages && product.productImages.length > 0">
              <div class="text-h6">제품 이미지</div>
              <div class="text-body-1 my-2">
                <v-row>
                  <div v-for="(image, i) in product.productImages" :key="i">
                    <v-card
                        class="mx-auto"
                        style="overflow: hidden"
                        max-width="100"
                        max-height="100"
                    >
                      <v-icon style="position: absolute; cursor:pointer" @click.once="uploadedRemove(image.fileId)">mdi mdi-delete</v-icon>
                      <img :src="`/attachment/product/${image.fileServerName}`" style="max-height: 240px; max-width: 220px; padding: 10px 10px 10px 10px"/>
                    </v-card>
                  </div>
                </v-row>
              </div>
            </div>

            <v-divider class="my-3"></v-divider>
            <div>
              <div class="text-h6">제품 내용</div>
              <div class="text-body-1 my-2">
                <editor-quill :val="product.productDetail" ref="contents"/>
              </div>
            </div>

          </v-form>
          <div class="btnStyleBx">
            <div class="btnCommon justify-center">
<!--              <v-btn class="vBtn" color="#fafafa" @click="id ? $router.push(`/product/detail/${id}`) : $router.push('/product')" v-if="!id">-->
              <v-btn class="vBtn" color="#fafafa" @click="$router.push('/product')" v-if="!id">
                <v-icon left>mdi mdi-format-list-bulleted</v-icon>
                목록
              </v-btn>
              <v-btn class="vBtn" color="#fafafa" @click="$router.push(`/product/detail/${id}`)" v-if="id">
                <v-icon left>mdi mdi-keyboard-backspace</v-icon>
                이전
              </v-btn>
              <!--              <v-btn class="vBtn" color="#1991eb" dark @click="save">-->
              <v-btn class="vBtn" color="success" dark @click="save">
                <v-icon left>mdi mdi-content-save</v-icon>
                저장
              </v-btn>
            </div>
          </div>
<!--          <div class="d-flex">-->
<!--            <v-btn @click="id ? $router.push(`/product/detail/${id}`) : $router.push('/product')">취소</v-btn>-->
<!--            <v-spacer></v-spacer>-->
<!--            <v-btn color="success" @click="save">-->
<!--              <v-icon small>mdi mdi-content-save</v-icon>-->
<!--              저장-->
<!--            </v-btn>-->
<!--          </div>-->
        </div>

      </div>
    </div>

  </section>
</template>

<script>
import rules from "@/utils/rules";
import ProductApi from "@/api/ProductApi";
import Categories from './components/Categories'
import EditorQuill from "@/views/component/EditorQuillComponent";
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

export default {
  name: 'productForm',
  props: ['id'],
  components:{
    vueDropzone: vue2Dropzone,
    EditorQuill,
    Categories
  },
  data() {
    return {
      isLoading: false,
      breadcrumbs: [{
        text: '제품관리',
        disabled: false,
        to: '/product/list'
      }, {
        text: '제품상세',
        disabled: true,
        href: '#'
      }],
      rules,
      product: {
      },
      attachmentImages:[],
      selectedImageIndex: 0,
      rendered: false,
      dropzoneOptions: {
        url: `${process.env.VUE_APP_BASE_API}/products/upload/image`,
        thumbnailWidth: 150,
        maxFilesize: 10, // mb
        // maxFiles: 10,
        // acceptedFileTypes: "image/*",
        acceptedFiles: "image/*",
        headers: {
          // 'Authorization': `bearer ${this.$store.getters?.token ?? ''}`
        },
        uploadMultiple: false,
        clickable: true,
        addRemoveLinks: true
      }
    }
  },
  computed: {
  },
  methods: {
    selectCategory(v) {
      this.product.categoryId = v.categoryId;
    },
    async save() {
      if(!await this.$refs.formProduct.validate()) {
        window.scrollTo(0,50)
        alert("필수 입력 항목을 확인해주세요.")
        return
      }

      if(!this.product.categoryId) {
        alert("제품 분류를 선택해주세요");
        return
      }

      this.product.productDetail = this.$refs.contents.getValue();
      this.product.productImages = this.attachmentImages;
      ProductApi.save(this.product).then(() => {
        alert('저장되었습니다.')
        this.$router.push({path: `/product`})
      })
    },
    onlyNumber(e) {
      if(!e || (e.code.indexOf("Digit") !== 0 && e.code.indexOf("Numpad") !== 0)) {
        e.target.value = e.target.value.replace(/\D+/g, '')
        e.preventDefault();
        // e.stopPropagation();
        // return false;
      } else {
        if(e.code.indexOf("Numpad") === 0)
          e.target.value = this.product.price ? this.product.price.replace(/\D+/g, '') : e.key.replace(/\D+/g, '')
        else
          e.target.value = e.target.value.replace(/\D+/g, '')
        return true;
      }
      // const charCode = e.which ?e.which : e.keyCode;
    },
    getProduct() {
      if(this.id) {
        ProductApi.get(this.id).then(data => {
          this.$refs.formProduct.resetValidation();
          // console.log(data);
          this.product = data;
          this.attachmentImages = this.product.productImages;

          setTimeout(() => {
            this.rendered = true;
          }, 300)
        })
      }
    },
    uploadSuccess(uploadedFileInfo, res) {
      const file = {
        fileRealName: res.clientName,
        fileServerName: res.saveName,
        fileContextPath: res.contextPath,
        filePath: res.serverPath,
        fileSize: res.size,
        fileExt: res.ext,
        contentType:res.contentType,
        thumbnail: res.thumbnail,
        uploadedInfo: uploadedFileInfo.upload
      }
      this.attachmentImages = [...this.attachmentImages, file];
      // console.log(this.attachmentImages)

      // console.log(this.$refs.productDropzone.getAcceptedFiles())
    },
    processingEvent() {
      this.$refs.productDropzone.setOption('headers', {Authorization: `bearer ${sessionStorage.getItem("X-Token") ?? ''}`})
    },
    uploadRemove(f) {
      this.attachmentImages = this.attachmentImages.filter(a => a.uploadedInfo.uuid !== f.upload.uuid);
    },
    uploadedRemove(fileId) {
      this.attachmentImages = this.product.productImages = this.attachmentImages.filter(f => f.fileId !== fileId);
    }


  },
  mounted() {

    if (typeof this.id !== 'undefined') {
      this.getProduct()
    } else {
      this.product = {}
    }

  },
  created(){
    // this.$refs.formProduct.resetValidation()

    setTimeout(() => {
      this.dropzoneOptions.headers = {Authorization: `bearer ${this.$store.getters?.token ?? ''}`}
    }, 0);

  }
}
</script>
<style lang="scss">

.dropzone-custom-content {
  /*position: absolute;*/
  /*top: 50%;*/
  /*left: 50%;*/
  /*transform: translate(-50%, -50%);*/
  text-align: center;
}

.dropzone-custom-title {
  margin-top: 0;
  color: #00b782;
}

.subtitle {
  color: #314b5f;
}

.dropzone {
  height: 100%;
  max-height: 100%;
  //min-height:260px;
  //max-height:260px
}


</style>
